import { Emitter } from "@welshman/lib";
import { normalizeRelayUrl } from "@welshman/util";
import { Socket } from "./Socket.js";
import { ConnectionState } from "./ConnectionState.js";
import { ConnectionStats } from "./ConnectionStats.js";
import { ConnectionAuth } from "./ConnectionAuth.js";
import { ConnectionSender } from "./ConnectionSender.js";
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["Open"] = "open";
    ConnectionStatus["Closed"] = "Closed";
})(ConnectionStatus || (ConnectionStatus = {}));
const { Open, Closed } = ConnectionStatus;
export class Connection extends Emitter {
    url;
    socket;
    sender;
    state;
    stats;
    auth;
    status = Open;
    constructor(url) {
        super();
        if (url !== normalizeRelayUrl(url)) {
            console.warn(`Attempted to open connection to non-normalized url ${url}`);
        }
        this.url = url;
        this.socket = new Socket(this);
        this.sender = new ConnectionSender(this);
        this.state = new ConnectionState(this);
        this.stats = new ConnectionStats(this);
        this.auth = new ConnectionAuth(this);
        this.setMaxListeners(100);
    }
    emit = (type, ...args) => super.emit(type, this, ...args);
    send = async (message) => {
        if (this.status !== Open) {
            throw new Error(`Attempted to send message on ${this.status} connection`);
        }
        this.socket.open();
        this.sender.push(message);
    };
    open = () => {
        this.status = Open;
        this.socket.open();
        this.sender.worker.resume();
    };
    close = () => {
        this.status = Closed;
        this.socket.close();
        this.sender.worker.pause();
    };
    cleanup = () => {
        this.close();
        this.removeAllListeners();
    };
}
//# sourceMappingURL=Connection.js.map